(() => {
  if (window.coverlyCardDiscounts) return;
  const cache = new Map(), discounts = new WeakMap(), seen = new WeakSet();
  const queue = []; let active = 0;
  function render(el) {
    const discount = discounts.get(el);
    if (!discount) return;
    const currency = el.dataset.cardCurrency || 'USD';
    // The existing size calculator returns USD amounts.
    if (el.dataset.cardConfigured && currency !== 'USD') return;
    const pay = Number(el.dataset.cardConfigured || el.dataset.cardBase);
    const value = Number(discount.value);
    if (!(pay > 0) || !(value > 0)) return;
    // Calculator and leading prices are already net of the discount.
    // Reconstruct the undiscounted reference; never reduce the supplied price.
    let full;
    if (discount.type === 'percentage' && value < 1) full = Math.round(pay / (1 - value));
    else if (discount.type === 'amount' && discount.currencyCode === currency) full = pay + Math.round(value * 100);
    else return;
    if (!(pay < full)) return;
    const money = n => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency,minimumFractionDigits:n % 100 ? 2 : 0}).format(n / 100);
    const current = document.createElement('span'), old = document.createElement('s');
    current.textContent = (!el.dataset.cardConfigured && el.dataset.cardFrom === 'true' ? 'From ' : '') + money(pay);
    old.textContent = money(full);
    old.setAttribute('aria-label', 'Original price ' + money(full));
    el.replaceChildren(current, old);
  }
  function pump() {
    while (active < 2 && queue.length) {
      const {url, resolve} = queue.shift(); active++;
      fetch(url, {headers:{Accept:'application/json'}}).then(r => r.ok ? r.json() : null)
        .then(data => resolve(data?.auto_discount || null)).catch(() => resolve(null))
        .finally(() => { active--; pump(); });
    }
  }
  function load(el) {
    const url = new URL((window.Shopify?.routes?.root || '/') + 'apps/coverly/configurator', location.origin);
    url.searchParams.set('shopify_product_id', el.dataset.cardProduct);
    url.searchParams.set('currency', el.dataset.cardCurrency || 'USD');
    url.searchParams.set('country', el.dataset.cardCountry || 'US');
    const key = url.href;
    if (!cache.has(key)) cache.set(key, new Promise(resolve => { queue.push({url:key,resolve}); pump(); }));
    cache.get(key).then(discount => { if (discount && el.isConnected) { discounts.set(el,discount); render(el); } });
  }
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) { observer.unobserve(entry.target); load(entry.target); }
  }), {rootMargin:'150px'});
  function scan(root) {
    const elements = [...(root.matches?.('[data-card-product]') ? [root] : []), ...root.querySelectorAll('[data-card-product]')];
    elements.forEach(el => { if (!seen.has(el)) { seen.add(el); observer.observe(el); } });
  }
  window.coverlyCardDiscounts = {render};
  scan(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1) scan(node);
  }))).observe(document.body, {childList:true,subtree:true});
})();
